import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface showClient {
    name?: string;
    account_no?: string;
    serial_no?: string;
    tax_number?: string;
    phone?: string;
    fax?: string;
    mobile?: string;
    email?: string;
    website?: string;
    country?: string;
    government?: string;
    city?: string;
    postal_code?: string;
    department_number?: string;
    address_1?: string;
    address_2?: string;
    address_3?: string;
    type?: 'Cash' | 'Post Paid';
    debt_ceiling?: number;
    id?:number
}

// Show client state
export interface showClientState {
    isLoaded: boolean;
    isOpen: boolean;
    id: number;
    data: showClient;
}

const initialShowClientState: showClientState = {
    isLoaded: false,
    isOpen: false,
    id: 0,
    data: {

    }
}

// Show client slice
export const showClientSlice = createSlice({
    name: 'show_client',
    initialState: initialShowClientState,
    reducers: {
        setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoaded = payload
        },
        setData: (state, { payload }: PayloadAction<showClient>) => {
            state.data = payload
        },
        setIsOpen: (state, { payload }: PayloadAction<{ id: number, isOpen: boolean }>) => {
            state.isOpen = payload.isOpen
            state.id = payload.id
        }
    }
})